function tokenize(value) {
    return value.match(/[a-zA-Z]+|[0-9]+/g) || [];
}

function isNumericToken(token) {
    return /^[0-9]+$/.test(token);
}

function numericRange(start, end, step) {
    const values = [];
    const padLength = Math.max(start.length, end.length);
    let current = parseInt(start, 10);
    const last = parseInt(end, 10);
    while (current <= last) {
        values.push(current.toString().padStart(padLength, "0"));
        current = incrementNumeric(current, step);
    }
    return values;
}

function letterRange(start, end, step) {
    const values = [start];
    let current = start;
    while (current !== end && values.length <= 1000) {
        const next = incrementLetter(current, step);
        if (next === current) break;
        current = next;
        values.push(current);
    }
    return values;
}

// Genera los valores entre start y end respetando la estructura del codigo.
// Divide ambos en segmentos de letras/numeros (R3A => ["R","3","A"]) y combina
// el rango de cada segmento, para no perder los sufijos alfabeticos.
function generateValueBetween(start, end, step = 1) {
    const startTokens = tokenize(start.toString());
    const endTokens = tokenize(end.toString());

    if (startTokens.length === 0 || startTokens.length !== endTokens.length) {
        return [start.toString()];
    }

    let values = [""];
    for (let i = 0; i < startTokens.length; i++) {
        const from = startTokens[i];
        const to = endTokens[i];
        let segment;

        if (isNumericToken(from) && isNumericToken(to)) {
            segment = numericRange(from, to, step);
        } else if (!isNumericToken(from) && !isNumericToken(to)) {
            segment = letterRange(from, to, step);
        } else {
            return [start.toString()];
        }

        const combined = [];
        values.forEach((prefix) => {
            segment.forEach((value) => combined.push(prefix + value));
        });
        values = combined;
    }

    return values;
}

function incrementLetter(value, step) {
    const arr = value.split('');

    // Find the rightmost character that can be incremented
    let i = arr.length - 1;
    while (i >= 0 && (arr[i] === 'Z' || arr[i] > 'Z')) {
      i = i - 1;
    }

    if (i < 0) {
      // All characters are 'Z', so we need to add a new character 'A' at the beginning
      return 'A' + arr.join('').replace(/Z/g, 'A');
    }

    // Convert the character to its ASCII code and add the step
    const incrementedCharCode = arr[i].charCodeAt(0) + step;

    // Determine the new character based on the incremented ASCII code
    let newChar;
    if (incrementedCharCode > 90 && incrementedCharCode < 97) {
      newChar = String.fromCharCode(97); // Wrap around to 'a' if necessary
    } else if (incrementedCharCode > 122) {
      newChar = String.fromCharCode(65); // Wrap around to 'A' if necessary
    } else {
      newChar = String.fromCharCode(incrementedCharCode);
    }

    // Update the rightmost character with the new character
    arr[i] = newChar;

    // Reset all characters to the right of the incremented character to 'A'
    for (let j = i + 1; j < arr.length; j++) {
      arr[j] = 'A';
    }

    return arr.join('');
}
function incrementNumeric(str,step) {
    return parseInt(str) + parseInt(step);
}

export const ubicacionesUtils = {
    generateValueBetween,
};
